import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	threadTitleWithOthers: {
		id: 'dynamic-cards-search-page.search-result.thread-title-wth-others',
		// eslint-disable-next-line @atlassian/i18n/enforce-plural-rules, @atlassian/i18n/no-multiple-whitespaces
		defaultMessage: `
			{contributorCount, plural,
				=0 {}
				=1 {{name1} in }
				=2 {{name1} and {name2} in }
				=3 {{name1}, {name2}, and {name3} in }
				=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in }
				other {{name1}, {name2}, {name3}, and {overflowContributorCount} others in }
			}#{channelName}
			`,
		description:
			'The title of a thread in a search result to include many others. For example, "Alice, Bob, Charlie and 5 others #announcements"',
	},
	groupChatTitle: {
		id: 'dynamic-cards-search-page.search-result.thread-title-wth-others',
		// eslint-disable-next-line @atlassian/i18n/enforce-plural-rules, @atlassian/i18n/no-multiple-whitespaces
		defaultMessage: `
			{contributorCount, plural,
				=0 {Group message with external users}
				=1 {{name1}}
				=2 {{name1} and {name2}}
				=3 {{name1}, {name2}, and {name3}}
				=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other}
				other {{name1}, {name2}, {name3}, and {overflowContributorCount} others}
			}
			`,
	},
	externalPeopleLabel: {
		id: 'dynamic-cards-search-page.externalPeopleLabel',
		defaultMessage: 'External people #{channelName}',
		description: 'Label for external people in the search result title',
	},
	externalPersonLabel: {
		id: 'dynamic-cards-search-page.externalPersonLabel',
		defaultMessage: 'External person',
		description: 'Label for external person in the search result title',
	},
	unknownChannel: {
		id: 'dynamic-cards-search-page.search-result.unknown-channel-in-thread',
		defaultMessage: 'unknown-channel',
		description: 'Use to describe a channel when the name is not available',
	},
});
